import { Link } from 'react-router-dom';
import type { Empresa } from '@/api/types';
import { cn } from '@/lib/cn';
import { displayName } from '@/lib/empresa';
import { ScoreBadge, SinaisRow } from './ScoreBadge';
import { TagChips } from './TagChips';

const tempDot: Record<string, string> = {
  frio: 'bg-[color:var(--color-temp-frio)]',
  morno: 'bg-[color:var(--color-temp-morno)]',
  quente: 'bg-[color:var(--color-temp-quente)]',
};

export function EmpresaListRow({ e }: { e: Empresa }) {
  return (
    <Link
      to={`/empresas/${e.id}`}
      className="group grid grid-cols-[auto_1fr_auto_auto_auto] items-center gap-3 border-b border-border/50 px-4 py-2.5 transition-colors hover:bg-muted/40"
    >
      <span
        className={cn('h-1.5 w-1.5 rounded-full shrink-0', tempDot[e.temperatura_efetiva])}
        aria-label={e.temperatura_efetiva}
      />
      <div className="min-w-0 flex items-baseline gap-2">
        <span className="truncate text-[14px] font-medium">{displayName(e)}</span>
        <span className="truncate text-[11px] text-muted-foreground/80 lowercase">
          {[e.setor, e.cidade].filter(Boolean).join(' · ')}
        </span>
        {e.prioridade === 'alta' && (
          <span className="mono text-[11px] font-semibold text-destructive">!</span>
        )}
        <TagChips tags={e.tags} className="shrink-0" />
      </div>
      <SinaisRow e={e} className="shrink-0" />
      <ScoreBadge score={e.score_prospect} size="xs" />
      <span className="text-[11px] text-muted-foreground lowercase tracking-tight shrink-0 w-32 text-right group-hover:text-foreground transition-colors">
        {e.status_funil.replace(/_/g, ' ')}
      </span>
    </Link>
  );
}
